import debug from 'debug';

const log = debug('fus078/vendor/foundation');

System.import(
	/* webpackChunkName: "vendor/foundation@5.4.5" */
	'@vendor/foundation@5.4.5'
).then(() => {
	log('init');
	$(document).foundation({
		accordion: {
			//	callback used to animate open close
			//	TODO does not work properly with multi_expand: false
			//	to fix hook into toggled event on .accordion
			//	toggle contained .content divs using accordion settings
			multi_expand: true,
			callback: function (panel) {
				var isOpen = panel.hasClass('active');
				panel.slideToggle(isOpen);
			}
		}
	});
	log('init.done');

});



// WEBPACK FOOTER //
// ./client/src/site__fus078/vendor/foundation.init.js